module.exports = __webpack_public_path__ + "static/media/mail.8c8df6a0.svg";